import { createElement, useState } from "react";

import clsx from "clsx";

import Button from "@/design-system/button";
import { useLocationContext } from "@/src/contexts/LocationContext";
import LocationModal from "@/src/location/LocationModal";
import * as stylex from "@stylexjs/stylex";

import LocationIcon from "../common/icons/LocationIcon";
import { ComposableSpacing, type PropsWithStyleX } from "./../../styles/tokens.stylex";

import * as css from "./LocationInfo.module.css";

export interface ILocationInfo extends PropsWithStyleX {
    title?: string;
    color?: string;
    titleElement?: string;
    className?: string;
    btnStyleX?: PropsWithStyleX["styleX"];
}

export function LocationInfo(props: ILocationInfo) {
    const [show, setShow] = useState(false);
    const { location } = useLocationContext();

    if (!location?.placeDescription) {
        return null;
    }

    const onModelClose = () => setShow(false);
    const showLocationModal = () => setShow(true);

    const renderLocationTitle =
        props.title && createElement(props.titleElement || "div", undefined, props.title);

    const colorStyle = styles.link(props.color || "#07c");

    return (
        <div
            className={clsx(
                css.locationInfoComponent,
                props.className,
                props.styleX ? stylex.props(props.styleX).className : null,
            )}
        >
            {renderLocationTitle}
            <Button
                as="button"
                size="None"
                variant="transparent"
                onClick={showLocationModal}
                styleX={[styles.baseStyle, colorStyle, props.btnStyleX]}
            >
                <span {...stylex.props(styles.baseStyle, styles.icon, colorStyle)}>
                    <LocationIcon />
                </span>
                <span>{location.placeDescription}</span>
            </Button>
            {show && <LocationModal onClose={onModelClose} />}
        </div>
    );
}

const styles = stylex.create({
    link: (myColor: string) => ({
        color: myColor,
    }),

    icon: {
        height: "1.2em",
        width: "1.2em",
    },

    baseStyle: {
        padding: 0,
        gap: ComposableSpacing.s1,
        alignItems: "center",
        display: "inline-flex",
        fontSize: "1rem",
    },
});
